import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function PainSection() {
  return <SectionWrapper id="dolor" withGlow glowPosition="top" data-id="element-289">
      <div className="max-w-3xl mx-auto text-center" data-id="element-290">
        {/* Opening hook */}
        <p className="text-[#c9a84c] text-sm font-semibold tracking-[0.2em] uppercase mb-6" data-id="element-291">
          Esto es lo que nadie te dice
        </p>

        <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8e6e1] mb-12 leading-tight" data-id="element-292">
          Sabes <span className="italic text-gold-gradient" data-id="element-293">exactamente</span>{' '}
          lo que se siente...
        </h2>

        <div className="space-y-8 text-left" data-id="element-294">
          <div className="border-l-2 border-[#c9a84c]/30 pl-6 md:pl-8" data-id="element-295">
            <p className="text-lg md:text-xl text-[#9a9aab] leading-relaxed" data-id="element-296">
              Prometerte a ti mismo que{' '}
              <span className="text-[#e8e6e1] font-medium" data-id="element-297">
                esta vez sí vas a cambiar
              </span>
              ... empezar con toda la energía del mundo un lunes... y para el
              jueves ya abandonaste.
              <span className="text-[#c9a84c]" data-id="element-298"> Otra vez.</span>
            </p>
          </div>

          <div className="border-l-2 border-[#c9a84c]/30 pl-6 md:pl-8" data-id="element-299">
            <p className="text-lg md:text-xl text-[#9a9aab] leading-relaxed" data-id="element-300">
              Sentir esa{' '}
              <span className="text-[#e8e6e1] font-medium" data-id="element-301">
                culpa silenciosa
              </span>{' '}
              que te come por dentro cuando sabes que no estás dando lo que
              puedes dar. Cuando te acuestas y piensas:
              <span className="italic text-[#e8e6e1]" data-id="element-302">
                {' '}
                "¿Qué estoy haciendo con mi vida?"
              </span>
            </p>
          </div>

          <div className="border-l-2 border-[#c9a84c]/30 pl-6 md:pl-8" data-id="element-303">
            <p className="text-lg md:text-xl text-[#9a9aab] leading-relaxed" data-id="element-304">
              Ver cómo{' '}
              <span className="text-[#e8e6e1] font-medium" data-id="element-305">el tiempo pasa</span>{' '}
              y tú sigues en el mismo lugar. Los mismos hábitos. Las mismas
              excusas. La misma frustración. Mientras otros avanzan, tú te
              sientes{' '}
              <span className="text-[#c9a84c]" data-id="element-306">atrapado en un ciclo</span> que
              no puedes romper.
            </p>
          </div>

          <div className="border-l-2 border-[#c9a84c]/30 pl-6 md:pl-8" data-id="element-307">
            <p className="text-lg md:text-xl text-[#9a9aab] leading-relaxed" data-id="element-308">
              Tener{' '}
              <span className="text-[#e8e6e1] font-medium" data-id="element-309">
                la mente llena de ruido
              </span>
              . Ansiedad. Pensamientos que no paran. Una sensación constante de
              que algo está mal pero no sabes exactamente qué.
              <span className="text-[#c9a84c]" data-id="element-310">
                {' '}
                Y nadie a tu alrededor lo entiende.
              </span>
            </p>
          </div>
        </div>

        {/* Transition statement */}
        <div className="mt-16 pt-12 border-t border-[#252b45]" data-id="element-311">
          <p className="text-xl md:text-2xl text-[#e8e6e1] font-display leading-relaxed" data-id="element-312">
            Si leíste esto y sentiste que alguien finalmente puso en palabras lo
            que llevas cargando...
          </p>
          <p className="text-lg md:text-xl text-[#c9a84c] mt-4 font-semibold" data-id="element-313">
            No es coincidencia que estés aquí.
          </p>
        </div>
      </div>
    </SectionWrapper>;
}